








import { Component, Vue } from 'vue-property-decorator';
import APP_CONFIG from '../../config';

@Component
export default class HeaderBar extends Vue {
    public logoAlt = APP_CONFIG.LOGO_ALT;
}
